import React, { FC, useEffect } from 'react'
import { RouteProps, useHistory } from 'react-router'
import { Location } from 'history'

// Components
import IndexLayout, { Title } from 'components/IndexLayout'
import { useToast } from '@sketch/toasts'
import AboutYouForm from '../../components/AboutYouForm'
import SignUpBreadcrumbs from '../../components/SignUpBreadcrumbs'

// Utils
import { trackEvent } from 'modules/analytics'

// Constants
import { routes } from '@sketch/constants'
import { useQueryParams } from 'utils'

// Types
import { useGetInitialUserQuery } from '@sketch/gql-types'

interface LocationState {
  from: Location
}
interface AboutYouViewProps extends RouteProps<'ABOUT_YOU'> {
  location: Location<LocationState>
}

const AboutYouView: FC<AboutYouViewProps> = ({ location }) => {
  const history = useHistory()

  const queryParams = useQueryParams<'ABOUT_YOU'>()

  const willContinueToWorkspaceCreation =
    queryParams?.skipWorkspaceCreation !== 'true' &&
    (!location.state?.from ||
      location.state.from.pathname === routes.WORKSPACE_CREATE.create({}))

  const { showToast } = useToast()

  const { data } = useGetInitialUserQuery()
  useEffect(() => {
    // Redirect in case the user has already provided this information
    if (data?.me.professionalRole) {
      history.replace(routes.ENTRY.create({}))
    }
  }, [data, history])

  return (
    <IndexLayout headerLink="sign-in" variant="green">
      <SignUpBreadcrumbs
        showWorkspaceCrumbs={willContinueToWorkspaceCreation}
        currentCrumb={1}
      />

      <Title>Help Us Get to Know You</Title>

      <AboutYouForm
        onCompleted={() => {
          trackEvent('SIGN UP - "Help us get to know you" form success', {
            formContext: 'main',
            willContinueToWorkspaceCreation,
          })

          if (willContinueToWorkspaceCreation) {
            history.push(routes.WORKSPACE_CREATE.create({}), {
              fromSignUp: true,
            })
          } else {
            history.push(location.state?.from || routes.ENTRY.create({}))
          }
        }}
        onError={error => {
          showToast(error.message, 'negative')
        }}
      />
    </IndexLayout>
  )
}

export default AboutYouView
